import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class RoleGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const authRole = route.data.authenticatedRole;
        console.log(authRole);
        let user = JSON.parse(localStorage.getItem('currentUserId'));
        if (user && user.role && authRole.includes(user.role)) {
            // logged in so return true
            console.log("in guards authentication")
            return true;
        }
        // not logged in or role not authorized, redirect to login page
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/_guards/role.guard.ts